import * as vp from 'vopay';

import { useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

const initHook = vopayApi.withApiHook(({ api }) => {
  return function useRailzTrackingCategories() {
    const source = axios.CancelToken.source();

    const [trackingCategories, setTrackingCategories] = useState<vp.RailzTrackingCategory[]>();

    const [, setDataFetchingInfo] = useDataFetchIndicator();

    const fetchTrackingCategories = async (requestParams: vp.RailzTrackingCategoriesRequest) => {
      try {
        setDataFetchingInfo(true, 'loading some data', 'fullScreen');
        const res = await api.railzTrackingCategories(requestParams, source);
        setTrackingCategories(res.TrackingCategories);
        return res;
      } finally {
        setDataFetchingInfo(false);
      }
    };
    const reset = () => {
      setTrackingCategories(undefined);
    };

    return {
      trackingCategories,
      fetchTrackingCategories,
      reset,
    };
  };
});

export default initHook({});
